/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  enquiry: ModelRegistry['enquiry'];
}

interface EnquiryGuestCardSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiEnquiryGuestCardV1Component extends Component<EnquiryGuestCardSignature> {
  dateFormat = 'EEE, MMM do';

  @cached
  get enquiry(): ModelRegistry['enquiry'] {
    return this.args.enquiry;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Enquiry::Guest::Card::V1': typeof UiEnquiryGuestCardV1Component;
  }
}
